/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined, EyeOutlined, FilterOutlined, RightCircleTwoTone, DownCircleTwoTone } from '@ant-design/icons';
import {
    Button, Form,
    Input,
    Modal,
    Space,
    Table,
    Tabs,
    Tooltip,
    Typography,
    Upload, notification, DatePicker, Drawer, Select, Layout, Row, Col, Card,
    Radio
} from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import history from '../../services/history';

import { AddOrUpdateConfigData, getConfogListFromDatabse } from '../../redux/Pricing gudiance/saga';


const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
//const { TabPane } = Tabs;
//const { Column } = Table;
//const { Search } = Input;

//const { Option } = Select;
const Data360Config = (props) => {

    const {
        setConfigData, setFormData, formData, ConfigData, showConfiguration, Contractor, setShowConfiguration
    } = props;


    const [SaveLoading, setSaveLoading] = useState(false);
    const [isInputfeildChanged, setIsInputfeildChanged] = useState(false)
    // useEffect(() => {


    //     {
    //         (async () => {


    //             const config = await getConfogListFromDatabse()
    //             console.log('confog', config)
    //             if (config && config[0] && config[0].Configuration) {
    //                 setConfigData(config[0])
    //                 setFormData(config[0].Configuration)
    //             }
    //             //setFormData(config.Configuration)
    //         })();
    //     }


    // }, [])

    /** get user Access */

    const OnSave = async () => {
        setSaveLoading(true);

        const data = {
            ID: ConfigData.ID,
            Configuration: formData
        }
        console.log(data)
        await AddOrUpdateConfigData(data)
        setIsInputfeildChanged(false)
        setSaveLoading(false);

    }

    const handleInputChange = (category, type, value) => {
        //setIsInputfeildChanged(true)
        //const category = 'Power_Supplies'
        //setShowPricingTable(false)
        setIsInputfeildChanged(true)
        setFormData((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };
            updatedCategory[type] = value;


            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });
    }


    const getCategoryValue1 = (category, type) => {
        if (formData.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            return formData[category][type]; // Return the value for the category
        }
    };

    const handleInputChange1 = (category, type, value) => {
        const maincategory = 'Others'
        setIsInputfeildChanged(true)
        setFormData((prevOptions) => {
            // Spread the previous state to avoid mutations
            return {
                ...prevOptions,  // Spread the outermost object
                [maincategory]: {   // Spread the maincategory
                    ...prevOptions[maincategory],  // Keep other categories intact
                    [category]: {  // Spread the specific category to update only the nested type
                        ...prevOptions[maincategory][category],
                        [type]: value,  // Update the specific type with the new value
                    },
                },
            };
        });
    };


    const getCategoryValue2 = (category, type) => {
        const maincategory = 'Others'
        if (formData.hasOwnProperty(maincategory) && formData[maincategory].hasOwnProperty(category)) {
            return formData[maincategory][category][type]; // Return the value for the category and type
        }
        return ''; // Return an empty string or fallback value if not found
    };

    const getPricingTabpanes = () => {
        return (
            <div className="custom-tab h-100" style={{ paddingTop: '10px' }}>


                <div className="flex-auto">

                    {showConfiguration && <div>

                        <Form
                            layout="vertical"
                            autoComplete="off"
                            getcontainer={false}
                            style={{ alignItems: 'center' }}
                        // onFinish={onFinish}
                        //onValuesChange={handleValueChange}

                        >
                            <Row gutter={16}>
                                <Col span={4}>
                                    <Card title="Hardware" className='Data360_Prcing-card' style={{ height: '95%' }}>
                                        <Form.Item label="Unit Cost" name="Unit_cost">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>

                                                <Input addonBefore={<div style={{ width: '100%', textAlign: 'center' }}>$</div>} className='Data360-addbefore'
                                                    value={getCategoryValue1('Hardware', 'Unit_cost')}
                                                    onChange={(e) => handleInputChange('Hardware', 'Unit_cost', Number(e.target.value))}
                                                    min={0}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'
                                                />
                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Utilization" name="Utilization">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input addonAfter='%' className='Data360-addafter'
                                                    value={getCategoryValue1('Hardware', 'Utilization') * 100}
                                                    onChange={(e) => handleInputChange('Hardware', 'Utilization', Number(e.target.value) / 100)}
                                                    min={1}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'
                                                />

                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Profit Margin" name="HW_Profit_Margin">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input addonAfter='%' className='Data360-addafter'
                                                    value={getCategoryValue1('Hardware', 'Margin') * 100}
                                                    onChange={(e) => handleInputChange('Hardware', 'Margin', Number(e.target.value) / 100)}
                                                    min={1}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'
                                                />

                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Rental Rate" name="Rental_rate">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input addonAfter='%' className='Data360-addafter'
                                                    value={getCategoryValue1('Hardware', 'Rental_rate') * 100}
                                                    onChange={(e) => handleInputChange('Hardware', 'Rental_rate', Number(e.target.value) / 100)}
                                                    min={1}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'
                                                />

                                            </div>
                                        </Form.Item>
                                    </Card>
                                </Col>
                                <Col span={4} offset={1}>
                                    {/* Application Section */}
                                    <Card title="Application" className="Data360_Prcing-card" style={{ height: '95%' }}>
                                        <Form.Item label="Pay Back Period (months)" name="Payback_Period" >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input
                                                    onChange={(e) => handleInputChange('Application', 'Payback_Period', Number(e.target.value))}
                                                    value={getCategoryValue1('Application', 'Payback_Period')}
                                                    min={0}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'

                                                />
                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Development Cost" name="Dev_cost">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>

                                                <Input addonBefore='$' className='Data360-addbefore'
                                                    onChange={(e) => handleInputChange('Application', 'Dev_cost', Number(e.target.value))}
                                                    value={getCategoryValue1('Application', 'Dev_cost')}
                                                    min={0}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'
                                                />
                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Profit Margin" name="SW_Profit_Margin">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input addonAfter='%' className='Data360-addafter'
                                                    value={getCategoryValue1('Application', 'Margin') * 100}
                                                    onChange={(e) => handleInputChange('Application', 'Margin', (Number(e.target.value) / 100))}
                                                    min={0}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'
                                                />

                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Units per Year" name="Units_per_Year">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input
                                                    onChange={(e) => handleInputChange('Application', 'Units_per_Year', Number(e.target.value))}
                                                    value={getCategoryValue1('Application', 'Units_per_Year')}
                                                    min={0}
                                                    type='number'
                                                    style={{ width: '100%', textAlign: 'center' }} size='large'
                                                />
                                            </div>
                                        </Form.Item>
                                    </Card>
                                </Col>
                                <Col span={4} offset={1}>
                                    {/* License Weightage */}
                                    <Card title="License Weightage" className="Data360_Prcing-card" style={{ height: '95%' }}>
                                        <Form.Item label="Basic" name="Basic">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input
                                                    onChange={(e) => handleInputChange('License_weightage', 'Basic', Number(e.target.value))}
                                                    value={getCategoryValue1('License_weightage', 'Basic')}
                                                    min={0}
                                                    type='number' size='large'
                                                    style={{ width: '100%', textAlign: 'center' }}
                                                />
                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Standard" name="Standard">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input
                                                    onChange={(e) => handleInputChange('License_weightage', 'Standard', Number(e.target.value))}
                                                    value={getCategoryValue1('License_weightage', 'Standard')}
                                                    min={0}
                                                    type='number' size='large'
                                                    style={{ width: '100%', textAlign: 'center' }}
                                                />
                                            </div>
                                        </Form.Item>

                                        <Form.Item label="Premium" name="Premium">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Input
                                                    onChange={(e) => handleInputChange('License_weightage', 'Premium', Number(e.target.value))}
                                                    value={getCategoryValue1('License_weightage', 'Premium')}
                                                    min={0}
                                                    type='number' size='large'
                                                    style={{ width: '100%', textAlign: 'center' }}
                                                />
                                            </div>
                                        </Form.Item>
                                    </Card>

                                </Col>
                                {Contractor == 'Sale' &&
                                    <Col span={4} offset={1}>

                                        <Card title="License Duration Weightage" className="Data360_Prcing-card" style={{ height: '95%' }}>
                                            <Form layout="vertical">

                                                <Form.Item label="1 year" name="1_year">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>

                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_weightage', '1_year', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_weightage', '1_year')}
                                                            min={0}
                                                            type='number'
                                                            size='large'
                                                            style={{ width: '90%', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                </Form.Item>

                                                <Form.Item label="2 year" name="2_year">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_weightage', '2_year', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_weightage', '2_year')}
                                                            min={0}
                                                            type='number'
                                                            size='large'
                                                            style={{ width: '90%', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                </Form.Item>

                                                <Form.Item label="3 year" name="3_year">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_weightage', '3_year', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_weightage', '3_year')}
                                                            min={0}
                                                            type='number'
                                                            size='large'
                                                            style={{ width: '90%', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                </Form.Item>

                                                <Form.Item label="5 year" name="5_year">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_weightage', '5_year', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_weightage', '5_year')}
                                                            min={0}
                                                            type='number'
                                                            size='large'
                                                            style={{ width: '90%', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                </Form.Item>

                                                <Form.Item label="Perpetual" name="Perpetual">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_weightage', 'Perpetual', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_weightage', 'Perpetual')}
                                                            min={0}
                                                            type='number'
                                                            size='large'
                                                            style={{ width: '100%', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                </Form.Item>

                                            </Form>
                                        </Card>


                                    </Col>
                                }{Contractor == 'Rent' &&
                                    <Col span={4} offset={1}>

                                        <Card title="License Duration Discount" className="Data360_Prcing-card" style={{ height: '95%' }}>
                                            <Form layout="vertical">

                                                <Form.Item label="<12 Month" name="<12">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input onChange={(e) => handleInputChange('License_duration_discount', '<12', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_discount', '<12')}
                                                            style={{ width: '100%', textAlign: 'center' }}
                                                            min={0}
                                                            type="number"
                                                            size="large"
                                                        />

                                                    </div>

                                                </Form.Item>

                                                <Form.Item label="13 to 24 Month" name="2_year">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_discount', '13to24', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_discount', '13to24')}
                                                            style={{ width: '100%', textAlign: 'center' }}
                                                            min={0}
                                                            type="number"
                                                            size="large"
                                                        />
                                                    </div>
                                                </Form.Item>

                                                <Form.Item label="25 to 36 Month" name="25to36">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_discount', '25to36', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_discount', '25to36')}
                                                            style={{ width: '100%', textAlign: 'center' }}
                                                            min={0}
                                                            type="number"
                                                            size="large"
                                                        />
                                                    </div>
                                                </Form.Item>

                                                <Form.Item label="37 to 60 Month" name="37to60">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_discount', '37to60', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_discount', '37to60')}
                                                            style={{ width: '100%', textAlign: 'center' }}
                                                            min={0}
                                                            type="number"
                                                            size="large"
                                                        />
                                                    </div>
                                                </Form.Item>


                                                <Form.Item label="Perpetual" name="Perpetual">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Input
                                                            onChange={(e) => handleInputChange('License_duration_discount', 'Perpetual', Number(e.target.value))}
                                                            value={getCategoryValue1('License_duration_discount', 'Perpetual')}
                                                            style={{ width: '100%', textAlign: 'center' }}
                                                            min={0}
                                                            type="number"
                                                            size="large"
                                                        />
                                                    </div>
                                                </Form.Item>

                                                {/* Add any additional items here */}

                                            </Form>
                                        </Card>


                                    </Col>
                                }
                                <Col span={4} offset={1}>
                                    {/* Other Costs Section */}
                                    <Card title="Other Costs" className="Data360_Prcing-card" style={{ height: '95%' }}>
                                        <Form layout="vertical">

                                            <Form.Item label="Internet Fee" name="Internet_Fee">
                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <Input addonBefore='$' className='Data360-addbefore'
                                                        onChange={(e) => handleInputChange1('Recurring', 'Internet', Number(e.target.value))}
                                                        value={getCategoryValue2('Recurring', 'Internet')}
                                                        min={0}
                                                        type="number"
                                                        size="large"
                                                        style={{ width: '100%', textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Form.Item>

                                            <Form.Item label="AWS" name="Cloud_fee">
                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <Input addonBefore='$' className='Data360-addbefore'
                                                        onChange={(e) => handleInputChange1('Recurring', 'AWS', Number(e.target.value))}
                                                        value={getCategoryValue2('Recurring', 'AWS')}
                                                        min={0}
                                                        type="number"
                                                        size="large"

                                                        style={{ width: '100%', textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Form.Item>

                                            <Form.Item label="Maintenance & Support" name="Maintenance_Support">
                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <Input addonBefore='$' className='Data360-addbefore'
                                                        onChange={(e) => handleInputChange1('Recurring', 'Maintenance', Number(e.target.value))}
                                                        value={getCategoryValue2('Recurring', 'Maintenance')}
                                                        min={0}
                                                        type="number"
                                                        size="large"
                                                        style={{ width: '100%', textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Form.Item>

                                            <Form.Item label="Premium Charges" name="Premium_Charges">
                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <Input addonBefore='$' className='Data360-addbefore'
                                                        onChange={(e) => handleInputChange1('Recurring', 'Premium', Number(e.target.value))}
                                                        value={getCategoryValue2('Recurring', 'Premium')}
                                                        min={0}
                                                        type="number"
                                                        size="large"
                                                        style={{ width: '100%', textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Form.Item>

                                            <Form.Item label="One Time Training Cost" name="One_Time_Training_Cost">
                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <Input addonBefore='$' className='Data360-addbefore'
                                                        onChange={(e) => handleInputChange1('One_time', 'Training_Cost', Number(e.target.value))}
                                                        value={getCategoryValue2('One_time', 'Training_Cost')}
                                                        min={0}
                                                        type="number"
                                                        size="large"
                                                        style={{ width: '100%', textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Form.Item>

                                            <Form.Item label="One Time Premium" name="One_Time_Premium">
                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <Input addonBefore='$' className='Data360-addbefore'
                                                        onChange={(e) => handleInputChange1('One_time', 'Premium', Number(e.target.value))}
                                                        value={getCategoryValue2('One_time', 'Premium')}
                                                        min={0}
                                                        type="number"
                                                        size="large"
                                                        style={{ width: '100%', textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Form.Item>


                                        </Form>
                                    </Card>

                                </Col>
                            </Row>


                            <Form.Item>
                                {/* <Button type="primary" key="apply" shape="round" style={{ marginTop: '5px'  }}
                                                onClick={() => setShowConfiguration(false)}
                                            >
                                                Save
                                            </Button> */}
                                <Button
                                    key="apply"
                                    type="primary"
                                    onClick={() => OnSave()}
                                    disabled={!isInputfeildChanged}
                                    loading={SaveLoading}
                                    style={{
                                        borderRadius: '30px',
                                        position: "fixed",
                                        bottom: "20px",
                                        right: "30px",
                                        zIndex: 1000,
                                    }}
                                >
                                    Save
                                </Button>

                            </Form.Item>
                        </Form>
                    </div>

                    }

                </div>

            </div>
        );
    }



    return (

        <div className="d-flex flex-column h-100">
  <div className="custom-line" />
            {getPricingTabpanes()}
        </div>
    );
};
const mapStateToProps = ({ }) => {


    return {

    }
}

const mapDispatchToProps = {


}


export default connect(mapStateToProps, mapDispatchToProps)(Data360Config);

